import React, { useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { getBalanceNumber } from 'utils/formatBalance'
import { useTranslation } from 'contexts/Localization'
import { ChevronDown, ChevronUp } from 'react-feather'
import { Flex } from 'toonswap-uikit'
import Balance from 'components/Balance'
import { CoreTag } from 'components/Tags'
import EndTime from './PoolTable/EndTime'

interface Props {
  projectLink: string
  decimals: number
  totalStaked: BigNumber
  tokenName: string
  tokenAddress: string
  tokenDecimals: number
  startTime: number
  endTime: number
  isFinished: boolean
}

const StyledFooter = styled.div<{ isFinished: boolean }>`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: ${({ isFinished, theme }) => theme.colors[isFinished ? 'textDisabled2' : 'primary2']};
  padding: 16px 24px;
`

const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

// The chain tag as an outlined pill, as in the design
const ChainTag = styled.div`
  & > * {
    height: 32px;
    padding: 0 12px;
    border: 1px solid #ed952e !important;
    border-radius: 29.5px;
    background: transparent !important;
    font-size: 14px;
    font-weight: 500;
  }
`

const StyledDetailsButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: 0;
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  font-weight: 600;
  height: 32px;
  justify-content: center;
  outline: 0;
  padding: 0;
  &:hover {
    opacity: 0.9;
  }

  & > svg {
    margin-left: 4px;
  }
`

const Details = styled.div`
  margin-top: 24px;
`

const Row = styled(Flex)`
  align-items: center;
  justify-content: center;
`

const FlexFull = styled.div`
  flex: 1;
`
const Label = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.textDisabled};
`
const TokenLink = styled.a`
  font-size: 14px;
  text-decoration: none;
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
`

const PairInfoButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #59c2e3;
  cursor: pointer;
`

const EndTimeValue = styled.span<{ $isFinished?: boolean }>`
  color: ${({ $isFinished, theme }) => ($isFinished ? theme.colors.textDisabled : theme.colors.text)};
  font-size: 14px;
`

const CardFooter: React.FC<Props> = ({
  projectLink,
  decimals,
  tokenAddress,
  totalStaked,
  tokenName,
  tokenDecimals,
  isFinished,
  startTime,
  endTime,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()
  const Icon = isOpen ? ChevronUp : ChevronDown

  const handleClick = () => setIsOpen(!isOpen)

  return (
    <StyledFooter isFinished={isFinished}>
      <FooterRow>
        <ChainTag>
          <CoreTag />
        </ChainTag>
        <StyledDetailsButton onClick={handleClick}>
          {isOpen ? t('Hide') : t('Details')} <Icon size={16} />
        </StyledDetailsButton>
      </FooterRow>
      {isOpen && (
        <Details>
          <Row mb="4px">
            <FlexFull>
              <Label>{t('Total Staked')}</Label>
            </FlexFull>
            <Balance fontSize="14px" isDisabled={isFinished} value={getBalanceNumber(totalStaked, decimals)} />
          </Row>
          {/* {blocksUntilStart > 0 && (
            <Row mb="4px">
              <FlexFull>
                <Label>{t('Start')}:</Label>
              </FlexFull>
              <Balance fontSize="14px" isDisabled={isFinished} value={blocksUntilStart} decimals={0} />
            </Row>
          )} */}
          {endTime > 0 && (
            <Row mb="4px">
              <FlexFull>
                <Label>{t('End Time')}:</Label>
              </FlexFull>
              <EndTimeValue $isFinished={isFinished}>
                <EndTime endTime={endTime} />
              </EndTimeValue>
            </Row>
          )}
          {/* {tokenAddress && (
            <Flex mb="4px">
              <TokenLink onClick={() => registerToken(tokenAddress, tokenName, tokenDecimals, imageSrc)}>
                {t('Add to Metamask')}
              </TokenLink>
              <MetamaskIcon height={15} width={15} ml="4px" />
            </Flex>
          )} */}
          <a
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              cursor: 'pointer',
              width: '100%',
              justifyContent: 'space-between',
            }}
            href={projectLink}
          >
            <PairInfoButton>{t('View Project Site')}</PairInfoButton>
            <img src="/images/link_to.svg" alt="info" width={14} height={14} />
          </a>
        </Details>
      )}
    </StyledFooter>
  )
}

export default React.memo(CardFooter)
